<template>
  <div class="caipiao">
    <div class="caipiao-card">
      <div class="caipiao-top">
        <div class="caipiao-title">大乐透</div>
        <div class="caipiao-nav">
          <div :class="daletouIndex == 1 ? 'nav-active' : ''" @click="handleNavDlt(1)">1注</div>
          <div :class="daletouIndex == 2 ? 'nav-active' : ''" @click="handleNavDlt(2)">2注</div>
          <div :class="daletouIndex == 3 ? 'nav-active' : ''" @click="handleNavDlt(3)">3注</div>
          <div :class="daletouIndex == 4 ? 'nav-active' : ''" @click="handleNavDlt(4)">4注</div>
          <div :class="daletouIndex == 5 ? 'nav-active' : ''" @click="handleNavDlt(5)">5注</div>
        </div>
        <div class="caipiao-btn" v-show="!dltIsStart" @click="handleStartDlt">开始</div>
        <div class="caipiao-btn" v-show="dltIsStart" @click="handleStopDlt">停止</div>
      </div>
      <div class="caipiao-list">
        <template v-for="(item, index) in dltList">
          <div :key="index" class="caipiao-item">
            <div class="item-left">
              <template v-for="(red, i) in item.red">
                <span :key="i">{{red > 9 ? red : '0' + red}}</span>
              </template>
            </div>
            <div class="item-right">
              <template v-for="(blue, j) in item.blue">
                <span :key="j">{{blue > 9 ? blue : '0' + blue}}</span>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="caipiao-card" style="margin-top: 25px;">
      <div class="caipiao-top">
        <div class="caipiao-title">双色球</div>
        <div class="caipiao-nav">
          <div :class="shuangseqiuIndex == 1 ? 'nav-active' : ''" @click="handleNavSsq(1)">1注</div>
          <div :class="shuangseqiuIndex == 2 ? 'nav-active' : ''" @click="handleNavSsq(2)">2注</div>
          <div :class="shuangseqiuIndex == 3 ? 'nav-active' : ''" @click="handleNavSsq(3)">3注</div>
          <div :class="shuangseqiuIndex == 4 ? 'nav-active' : ''" @click="handleNavSsq(4)">4注</div>
          <div :class="shuangseqiuIndex == 5 ? 'nav-active' : ''" @click="handleNavSsq(5)">5注</div>
        </div>
        <div class="caipiao-btn" v-show="!ssqIsStart" @click="handleStartSsq">开始</div>
        <div class="caipiao-btn" v-show="ssqIsStart" @click="handleStopSsq">停止</div>
      </div>
      <div class="caipiao-list">
        <template v-for="(item, index) in ssqList">
          <div :key="index" class="caipiao-item">
            <div class="item-left">
              <template v-for="(red, i) in item.red">
                <span :key="i">{{red > 9 ? red : '0' + red}}</span>
              </template>
            </div>
            <div class="item-right">
              <template v-for="(blue, j) in item.blue">
                <span :key="j">{{blue > 9 ? blue : '0' + blue}}</span>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  var timer1 = null
  var timer2 = null
  export default {
    name: 'caipiao',

    metaInfo () {
      return {
        title:'彩票机选'
      }
    },

    data () {
      return {
        daletouIndex: 1,
        shuangseqiuIndex: 1,
        dltIsStart: false,
        ssqIsStart: false,
        dltList: [],
        ssqList: []
      }
    },

    methods: {
      handleNavDlt (index) {
        if(this.dltIsStart) {
          this.$message.warning('请先停止再选择')
          return false
        }
        if(index != this.daletouIndex) {
          this.daletouIndex = index
          this.dltList = []
        }
      },
      handleStartDlt () {
        if(this.dltIsStart) return false
        this.dltIsStart = true
        timer1 = setInterval(() => {
          var arr = []
          for(var i = 0; i < this.daletouIndex; i ++) {
            arr.push(this.getDlt())
          }
          this.dltList = arr
        }, 100)
      },
      handleStopDlt () {
        clearInterval(timer1)
        this.dltIsStart = false
      },
      getDlt () {
        var reds = [parseInt(Math.random() * 35 + 1)]
        var blues = [parseInt(Math.random() * 12 + 1)]
        var obj = {}
        while(reds.length  < 5) {
          var r = parseInt(Math.random() * 35 + 1)
          for(var i = 0; i < reds.length; i ++) {
            if(reds[i] == r) {
              break
            } else if (i == reds.length - 1) {
              reds.push(r)
            }
          }
        }
        while(blues.length  < 2) {
          var r = parseInt(Math.random() * 12 + 1)
          for(var i = 0; i < blues.length; i ++) {
            if(blues[i] == r) {
              break
            } else if (i == blues.length - 1) {
              blues.push(r)
            }
          }
        }
        obj.red = reds
        obj.blue = blues
        return obj
      },





      handleNavSsq (index) {
        if(this.ssqIsStart) {
          this.$message.warning('请先停止再选择')
          return false
        }
        if(index != this.shuangseqiuIndex) {
          this.shuangseqiuIndex = index
          this.ssqList = []
        }
      },

      handleStartSsq () {
        if(this.ssqIsStart) return false
        this.ssqIsStart = true
        timer2 = setInterval(() => {
          console.log(111)
          var arr = []
          for(var i = 0; i < this.shuangseqiuIndex; i ++) {
            arr.push(this.getSsq())
          }
          this.ssqList = arr
        }, 100)
        
      },
      handleStopSsq () {
        clearInterval(timer2)
        this.ssqIsStart = false
      },

      getSsq () {
        var reds = [parseInt(Math.random() * 33 + 1)]
        var blues = [parseInt(Math.random() * 16 + 1)]
        var obj = {}
        while(reds.length  < 6) {
          var r = parseInt(Math.random() * 33 + 1)
          for(var i = 0; i < reds.length; i ++) {
            if(reds[i] == r) {
              break
            } else if (i == reds.length - 1) {
              reds.push(r)
            }
          }
        }
        obj.red = reds
        obj.blue = blues
        return obj
      },


    },

    destroyed () {
      clearInterval(timer1)
      clearInterval(timer2)
    }
  }
</script>

<style lang="less" scoped>
  .caipiao {
    color: #111111;
    padding: 15px;

    .caipiao-card {
      padding: 15px 0;
      border: 5px solid #df1414;
      border-top-width: 50px;
      border-radius: 10px;
      position: relative;

      .caipiao-top {
        position: absolute;
        top: -50px;
        left: 0;
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;

        .caipiao-title {
          font-size: 20px;
        }

        .caipiao-nav {
          display: flex;
        }

        .caipiao-nav div {
          margin-left: 5px;
          padding: 0 5px;
        }

        .caipiao-nav .nav-active {
          background-color: #00B0FF;
          border-radius: 5px;
        }

        .caipiao-btn {
          background-color: #CE3C39;
          color: #ffffff;
          padding: 2px 10px;
          border-radius: 5px;
          position: absolute;
          right: 10px;
        }

      }

      .caipiao-list {
        line-height: 30px;

        .caipiao-item {
          display: flex;
          justify-content: space-around;

          .item-left,
          .item-right {
            display: flex;
          }

          .item-left span {
            color: #df1414;
            font-size: 20px;
            width: 45px;
            text-align: center;
          }

          .item-right span {
            color: #00B0FF;
            font-size: 20px;
            width: 45px;
            text-align: center;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/caipiao.vue